import React, {useState} from "react";

const Titre = props => {
    return(
        <div className="titreSite" style={{fontFamily: "system-ui", fontWeight: "bold"}}>Restaurants</div>
    );
}

export default Titre;